import type { ITableSettings } from "../types";
import { calcCellText } from "./calc-cell-text";
import { getHeaderRowIndex } from "./get-header-row-index";
import { makeCellResolver } from "./resolve-cell-text";

export const deriveColumnUniqueValues = (
  settings: Pick<
    ITableSettings,
    | "tableData"
    | "tableCols"
    | "tableRows"
    | "tableHasHeader"
    | "tableHeaderPosition"
  >,
  col: number,
): string[] => {
  const {
    tableCols,
    tableRows,
    tableData,
    tableHasHeader,
    tableHeaderPosition,
  } = settings;
  if (!tableData || !tableCols || !tableRows) return [];
  if (col < 0 || col >= tableCols) return [];

  const headerRow = getHeaderRowIndex({
    tableRows,
    tableHasHeader,
    tableHeaderPosition,
  });

  const { resolveText } = makeCellResolver(tableData);
  const seen = new Set<string>();
  for (let row = 0; row < tableRows; row++) {
    if (row === headerRow) continue;
    const cell = tableData[col + row * tableCols];
    seen.add(
      calcCellText(cell, tableData, tableCols, tableRows, col, row) ??
        resolveText(cell),
    );
  }

  return Array.from(seen).sort((a, b) =>
    a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }),
  );
};
